import React from 'react';
import AcquisitionOption from './AcquisitionOption';

import { useLocationContext } from '../../context/LocationContext';

export default function MeetUpOption() {
  const { isMeetupAllowed = false } = useLocationContext();

  return isMeetupAllowed ? (
    <AcquisitionOption
      title="meet up"
      text="Meet us somewhere in the middle."
    />
  ) : null;
}
